import React from "react";
import { ActivityIndicator, Text, View } from "react-native";
import StyleSheet from "react-native-media-query";
import { ScreenNameList } from "@lib/utilities/Constants";
import { theme } from "../../theme/theme";
import { labelText } from "../../resources/strings";

const ActivityIndicatorLoader = (props: any) => {
  let screenName = props.data.screenName;
  let subtitle = "";
  let downloadLoader= props?.data

  if (screenName == "Payments") {
    subtitle = "Fetching payment details...";
  }
  if (screenName == ScreenNameList.choosePolicy) {
    subtitle = labelText.loading.fetchingYourPolicy;
  } else if (screenName == ScreenNameList.pdfViewer && downloadLoader?.downloadLoader) {
    subtitle = labelText.loading.downloadingDocument;
  } else if (screenName == ScreenNameList.pdfViewer) {
    subtitle = labelText.loading.loadingDocument;
  } else if (
    screenName == ScreenNameList.billingPayments ||
    screenName == ScreenNameList.contactAgent ||
    screenName == ScreenNameList.makeClaim ||
    screenName == ScreenNameList.documentInfo
  ) {
    subtitle = labelText.loading.loadingPolicyDetails;
  } else if (screenName == ScreenNameList.notificationCenter) {
    subtitle = labelText.loading.loadingNotifications;
  }

  const { ids, styles } = StyleSheet.create({
    container: {
      display: "flex",
      flex: 1,
      justifyContent: "center",
      paddingTop: theme.spacing.lg,
    },
    subMessageText: {
      color: props.data.color ? "#000" : "#fff",
      fontSize: theme.fontsize.reg,
      fontFamily: theme.fontFamily.robotoSlabRegular,
      textAlign: "center",
      marginTop: theme.spacing.md,
    },
    scrollArea: {
      display: "flex",
      flex: 1,
      justifyContent: "center",
    },
  });

  return (
    <View style={[styles.scrollArea]} dataSet={{ media: ids.scrollArea }}>
      <View style={[styles.container]}>
        <ActivityIndicator
          size="large"
          color={props.data.color ? "#000" : "#fff"}
          animating={props.indicator}
        />
        <Text
          style={styles.subMessageText}
          dataSet={{ media: ids.subMessageText }}
        >
          {subtitle}
        </Text>
      </View>
    </View>
  );
};

export default ActivityIndicatorLoader;
